import { lazy, Suspense } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import "./styles/classes.scss";
import "./styles/variables.scss";
import "./styles/styles.scss";
import "./App.css";

import { clientRoutes } from "./utils/routes";
import { AuthHelpers } from "./utils/auth.helpers";
import ScheduleAuctionList from "./pages/dashboard/workspace/workspaceShedule/SceduleAuctionList";
import ScheduleAuctionView from "./pages/dashboard/workspace/workspaceShedule/view/ScheduleAuctionView";
import ReviewPostList from "./pages/dashboard/workspace/reviewpost/list/ReviewPostList";
import ReviewPostView from "./pages/dashboard/workspace/reviewpost/view/ReviewPostView";
import ScheduleOpenHomeList from "./pages/dashboard/workspace/openhome/ScheduleOpenHomeList";
import AgencyOpenHomeDetailView from "./pages/dashboard/workspace/agencyopenhome/view/OpenHomeDetailView";
import OpenHomeDetailView from "./pages/dashboard/workspace/openhome/view/OpenHomeDetailView";
import OnBoardingPostList from "./pages/dashboard/workspace/onboarding/list/OnBoardingPostList";
import OnBoardingPostView from "./pages/dashboard/workspace/onboarding/view/OnBoardingPostView";
import AnnouncementPostList from "./pages/dashboard/workspace/announcement/list/AnnouncementPostList";
import AnnouncementPostView from "./pages/dashboard/workspace/announcement/view/AnnouncementPostView";
import PropertyBankList from "./pages/dashboard/propertyBank/list/PropertyBankList";
import CreatePropertyBank from "./pages/dashboard/propertyBank/create/CreatePropertyBank";
import EditPropertyBank from "./pages/dashboard/propertyBank/edit/EditPropertyBank";
import BrandList from "./pages/dashboard/brands/list/BrandList";
import CreateBrand from "./pages/dashboard/brands/create/CreateBrand";
import EditBrand from "./pages/dashboard/brands/edit/EditBrand";
import AgencyFonts from "./pages/dashboard/agencyFont/AgencyFonts";
import AgencyFontDetails from "./pages/dashboard/agencyFont/view/AgencyFontDetails";
import BrandFonts from "./pages/dashboard/brandFont/BrandFonts";
import BrandFontDetails from "./pages/dashboard/brandFont/view/BrandFontDetails";
import SystemFonts from "./pages/dashboard/systemFont/SystemFonts";
import SystemFontDetails from "./pages/dashboard/systemFont/view/SystemFontDetails";

const SignIn = lazy(() => import("./pages/auth/login/SignIn"));
const VerifyEmailAndPhone = lazy(
  () => import("./pages/auth/verifyLogin/VerifyEmailAndPhone"),
);

const ManageInvitesList = lazy(() => import("./pages/dashboard/manageInvite"));
const InvitationDetails = lazy(
  () => import("./pages/dashboard/manageInvite/view"),
);
const AgenciesList = lazy(() => import("./pages/dashboard/agency"));
const AgentsList = lazy(() => import("./pages/dashboard/agent"));
const AgentView = lazy(() => import("./pages/dashboard/agent/view"));
const EditAgent = lazy(() => import("./pages/dashboard/agent/edit"));
const AgencyView = lazy(() => import("./pages/dashboard/agency/view"));
const EditAgency = lazy(() => import("./pages/dashboard/agency/edit"));
const UsersList = lazy(() => import("./pages/dashboard/user"));
const HomeComponent = lazy(() => import("./pages/home/Home"));
const CreateUser = lazy(() => import("./pages/dashboard/user/create"));
const ResetPassword = lazy(
  () => import("./pages/auth/resetPassword/ResetPassword"),
);
const CreateNewPassword = lazy(
  () => import("./pages/auth/createNewPassword/CreateNewPassword"),
);
const UserDetailsView = lazy(() => import("./pages/dashboard/user/view"));
const SubscriptionsList = lazy(
  () => import("./pages/dashboard/subscriptions/list"),
);
const Workspace = lazy(() => import("./pages/dashboard/workspace"));
const PropertyPostList = lazy(
  () =>
    import("./pages/dashboard/workspace/propertypost/list/PropertyPostList"),
);
const PropertyPostView = lazy(
  () =>
    import("./pages/dashboard/workspace/propertypost/view/PropertyPostView"),
);
const CreateSubscription = lazy(
  () => import("./pages/dashboard/subscriptions/create"),
);
const TemplateTypesList = lazy(
  () => import("./pages/dashboard/designTemplateTypes/list"),
);
const CreateTemplateType = lazy(
  () => import("./pages/dashboard/designTemplateTypes/create"),
);
const EditTemplateType = lazy(
  () => import("./pages/dashboard/designTemplateTypes/edit"),
);
const EditSubscription = lazy(
  () => import("./pages/dashboard/subscriptions/edit"),
);
const DesignTemplates = lazy(
  () => import("./pages/dashboard/designTemplates/list"),
);
const CreateDesignTemplate = lazy(
  () => import("./pages/dashboard/designTemplates/create"),
);
const ViewDesignTemplate = lazy(
  () => import("./pages/dashboard/designTemplates/view"),
);
const ReferralsList = lazy(() => import("./pages/dashboard/referral/list"));
const CreateReferral = lazy(() => import("./pages/dashboard/referral/create"));
const ReferralDetailsView = lazy(
  () => import("./pages/dashboard/referral/view"),
);
const RoyaltyProgramList = lazy(
  () => import("./pages/dashboard/royaltyProgram/list"),
);
const CreateRoyalty = lazy(
  () => import("./pages/dashboard/royaltyProgram/create"),
);
const RoyaltyDetailsView = lazy(
  () => import("./pages/dashboard/royaltyProgram/view"),
);
const Properties = lazy(() => import("./pages/dashboard/properties/list"));
const PropertieView = lazy(() => import("./pages/dashboard/properties/view"));
const PropertieEdit = lazy(() => import("./pages/dashboard/properties/edit"));
const PropertyStagesList = lazy(
  () => import("./pages/dashboard/propertyStages/list"),
);
const CreatePropertyStage = lazy(
  () => import("./pages/dashboard/propertyStages/create"),
);
const EditStage = lazy(() => import("./pages/dashboard/propertyStages/edit"));
const ManualWalletPointsList = lazy(
  () => import("./pages/dashboard/manualWalletPoints/list"),
);
const CreateWalletPoint = lazy(
  () => import("./pages/dashboard/manualWalletPoints/create"),
);
const EditWalletPoint = lazy(
  () => import("./pages/dashboard/manualWalletPoints/edit"),
);
const AgencyAgentsList = lazy(
  () => import("./pages/dashboard/agency/view/agents"),
);

const AgencyProfileLogoColor = lazy(
  () => import("./pages/dashboard/agency/AgencyLogoColor"),
);

/**
 * TODO:
 *
 * Class for the recaptcha container
 * grecaptcha-badge
 *
 *
 */

const unprotectedRoutes = [clientRoutes.register, clientRoutes.login];

function App() {
  const navigate = useNavigate();
  const isUserLoggedIn = AuthHelpers.validateAccessToken();
  const location = useLocation();
  const pathname = location.pathname;
  let processRequest = true;

  let failedIterations = [];

  // if (!isUserLoggedIn) {
  //   processRequest = false;

  //   for (let index = 0; index < unprotectedRoutes.length; index++) {
  //     const route = unprotectedRoutes[index] as string;

  //     if (!pathname?.includes(route)) {
  //       failedIterations.push(true);
  //     }
  //   }

  //   if (failedIterations.length !== unprotectedRoutes.length) {
  //     processRequest = true;
  //   }
  // }

  // if (!processRequest) navigate(clientRoutes.login);

  return (
    <div className="App">
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route
            path={clientRoutes?.home}
            element={
              <Suspense fallback={<div></div>}>
                <HomeComponent />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.login}
            element={
              <Suspense fallback={<div></div>}>
                <SignIn />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.resetPassword}
            element={
              <Suspense fallback={<div></div>}>
                <ResetPassword />
              </Suspense>
            }
          />
          <Route
            path={clientRoutes.createPassword}
            element={
              <Suspense fallback={<div></div>}>
                <CreateNewPassword />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.resetPasswordVerify}
            element={
              <Suspense fallback={<div></div>}>
                <VerifyEmailAndPhone />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.verifyLogin}
            element={
              <Suspense fallback={<div></div>}>
                <VerifyEmailAndPhone />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencies}
            element={
              <Suspense fallback={<div></div>}>
                <AgenciesList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyEdit}
            element={
              <Suspense fallback={<div></div>}>
                <EditAgency />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencylogocolor}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyProfileLogoColor />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyAgentsDetails}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyAgentsList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.createPropertyBank}
            element={
              <Suspense fallback={<div></div>}>
                <CreatePropertyBank />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.propertyBank}
            element={
              <Suspense fallback={<div></div>}>
                <PropertyBankList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.BrandList}
            element={
              <Suspense fallback={<div></div>}>
                <BrandList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyFonts}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyFonts />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agencyFontDetails}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyFontDetails />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.brandFonts}
            element={
              <Suspense fallback={<div></div>}>
                <BrandFonts />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.brandFontDetails}
            element={
              <Suspense fallback={<div></div>}>
                <BrandFontDetails />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.systemFonts}
            element={
              <Suspense fallback={<div></div>}>
                <SystemFonts />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.systemFontDetails}
            element={
              <Suspense fallback={<div></div>}>
                <SystemFontDetails />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.createBrand}
            element={
              <Suspense fallback={<div></div>}>
                <CreateBrand />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.propertyBankView}
            element={
              <Suspense fallback={<div></div>}>
                <EditPropertyBank />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.BrandView}
            element={
              <Suspense fallback={<div></div>}>
                <EditBrand />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agents}
            element={
              <Suspense fallback={<div></div>}>
                <AgentsList />
              </Suspense>
            }
          />
          <Route
            path={clientRoutes.agentView}
            element={
              <Suspense fallback={<div></div>}>
                <AgentView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.agentEdit}
            element={
              <Suspense fallback={<div></div>}>
                <EditAgent />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.users}
            element={
              <Suspense fallback={<div></div>}>
                <UsersList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.userCreate}
            element={
              <Suspense fallback={<div></div>}>
                <CreateUser />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.userView}
            element={
              <Suspense fallback={<div></div>}>
                <UserDetailsView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.subscriptions}
            element={
              <Suspense fallback={<div></div>}>
                <SubscriptionsList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.subscriptionCreate}
            element={
              <Suspense fallback={<div></div>}>
                <CreateSubscription />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.subscriptionEdit}
            element={
              <Suspense fallback={<div></div>}>
                <EditSubscription />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.designTemplateTypes}
            element={
              <Suspense fallback={<div></div>}>
                <TemplateTypesList />
              </Suspense>
            }
          />
          <Route
            path={clientRoutes.designTemplateTypesCreate}
            element={
              <Suspense fallback={<div></div>}>
                <CreateTemplateType />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.designTemplateTypesEdit}
            element={
              <Suspense fallback={<div></div>}>
                <EditTemplateType />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.designTemplates}
            element={
              <Suspense fallback={<div></div>}>
                <DesignTemplates />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.workspace}
            element={
              <Suspense fallback={<div></div>}>
                <Workspace />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.PropertyPostList}
            element={
              <Suspense fallback={<div></div>}>
                <PropertyPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.AuctionList}
            element={
              <Suspense fallback={<div></div>}>
                <ScheduleAuctionList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.ReviewPostList}
            element={
              <Suspense fallback={<div></div>}>
                <ReviewPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.OnBoardingPostList}
            element={
              <Suspense fallback={<div></div>}>
                <OnBoardingPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AnnouncementPostList}
            element={
              <Suspense fallback={<div></div>}>
                <AnnouncementPostList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.OpenHomeList}
            element={
              <Suspense fallback={<div></div>}>
                <ScheduleOpenHomeList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.PropertyPostView}
            element={
              <Suspense fallback={<div></div>}>
                <PropertyPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AuctionView}
            element={
              <Suspense fallback={<div></div>}>
                <ScheduleAuctionView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.ReviewPostView}
            element={
              <Suspense fallback={<div></div>}>
                <ReviewPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.OnboardingPostView}
            element={
              <Suspense fallback={<div></div>}>
                <OnBoardingPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AnnouncementPostView}
            element={
              <Suspense fallback={<div></div>}>
                <AnnouncementPostView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.AgencyScheduleOpenHomeView}
            element={
              <Suspense fallback={<div></div>}>
                <AgencyOpenHomeDetailView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes?.agentOpenHomeView}
            element={
              <Suspense fallback={<div></div>}>
                <OpenHomeDetailView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.designTemplateCreate}
            element={
              <Suspense fallback={<div></div>}>
                <CreateDesignTemplate />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.designTemplateView}
            element={
              <Suspense fallback={<div></div>}>
                <ViewDesignTemplate />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.profileView}
            element={
              <Suspense fallback={<div></div>}>
                <UserDetailsView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.referrals}
            element={
              <Suspense fallback={<div></div>}>
                <ReferralsList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.referralCreate}
            element={
              <Suspense fallback={<div></div>}>
                <CreateReferral />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.referralView}
            element={
              <Suspense fallback={<div></div>}>
                <ReferralDetailsView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.royaltyProgram}
            element={
              <Suspense fallback={<div></div>}>
                <RoyaltyProgramList />
              </Suspense>
            }
          />
          <Route
            path={clientRoutes.royaltyCreate}
            element={
              <Suspense fallback={<div></div>}>
                <CreateRoyalty />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.manageInvites}
            element={
              <Suspense fallback={<div></div>}>
                <ManageInvitesList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.manageInvitesDetails}
            element={
              <Suspense fallback={<div></div>}>
                <InvitationDetails />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.royaltyView}
            element={
              <Suspense fallback={<div></div>}>
                <RoyaltyDetailsView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.properties}
            element={
              <Suspense fallback={<div></div>}>
                <Properties />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.propertieView}
            element={
              <Suspense fallback={<div></div>}>
                <PropertieView />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.propertieEdit}
            element={
              <Suspense fallback={<div></div>}>
                <PropertieEdit />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.propertyStages}
            element={
              <Suspense fallback={<div></div>}>
                <PropertyStagesList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.propertyStageCreate}
            element={
              <Suspense fallback={<div></div>}>
                <CreatePropertyStage />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.propertyStageEdit}
            element={
              <Suspense fallback={<div></div>}>
                <EditStage />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.manualWalletPoints}
            element={
              <Suspense fallback={<div></div>}>
                <ManualWalletPointsList />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.manualWalletPointsCreate}
            element={
              <Suspense fallback={<div></div>}>
                <CreateWalletPoint />
              </Suspense>
            }
          />

          <Route
            path={clientRoutes.manualWalletPointsEdit}
            element={
              <Suspense fallback={<div></div>}>
                <EditWalletPoint />
              </Suspense>
            }
          />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
